if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            
            // Check for Buy X Get Y free gift offer
            this.checkAndAddFreeGift(response);
            
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      async checkAndAddFreeGift(cartResponse) {
        try {
          // Check if Buy X Get Y offers data exists
          if (!window.buyXGetYOffers || window.buyXGetYOffers.length === 0) {
            return;
          }

          // Get the product ID from the form
          const productId = this.form.querySelector('[name="id"]').value;
          
          // Get the product handle from the data attribute
          const productHandle = this.dataset.productHandle;
          
          if (!productHandle) {
            console.log('Product handle not found');
            return;
          }

          // Find matching offer for this product
          const matchingOffer = window.buyXGetYOffers.find(offer => 
            offer.offerActive && offer.mainProductHandle === productHandle
          );

          if (!matchingOffer) {
            return;
          }

          const variantId = matchingOffer.freeGiftVariantId;

          // Check if free gift is already in cart to avoid duplicates
          const cartItems = cartResponse.items || [];
          const freeGiftAlreadyInCart = cartItems.some(item => 
            item.variant_id == variantId || 
            item.properties?._free_gift === 'true'
          );

          if (freeGiftAlreadyInCart) {
            return;
          }

          // Add free gift to cart with property to identify it
          const addFreeGiftConfig = fetchConfig('javascript');
          addFreeGiftConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete addFreeGiftConfig.headers['Content-Type'];

          const freeGiftFormData = new FormData();
          freeGiftFormData.append('id', variantId);
          freeGiftFormData.append('quantity', 1);
          freeGiftFormData.append('properties[_free_gift]', 'true');
          freeGiftFormData.append('properties[_free_gift_with]', productId);
          
          if (matchingOffer.displayMessage) {
            freeGiftFormData.append('properties[_gift_message]', matchingOffer.displayMessage);
          }
           if (matchingOffer.freeBadge) {
            freeGiftFormData.append('properties[_free_badge]', matchingOffer.freeBadge);
          }

          if (this.cart) {
            freeGiftFormData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            freeGiftFormData.append('sections_url', window.location.pathname);
          }

          addFreeGiftConfig.body = freeGiftFormData;

          const freeGiftResponse = await fetch(`${routes.cart_add_url}`, addFreeGiftConfig);
          const freeGiftData = await freeGiftResponse.json();

          if (freeGiftData.status) {
            console.log('Could not add free gift:', freeGiftData.description);
            return;
          }

          // Update cart display with free gift
          if (this.cart) {
            this.cart.renderContents(freeGiftData);
          }

          // Show notification about free gift
          if (matchingOffer.displayMessage) {
            this.showFreeGiftNotification(matchingOffer.displayMessage);
          }
          
        } catch (error) {
          console.error('Error checking for free gift:', error);
        }
      }

      showFreeGiftNotification(message) {
        // Create a temporary notification
        const notification = document.createElement('div');
        notification.className = 'free-gift-notification';
        notification.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          background: #4CAF50;
          color: white;
          padding: 15px 20px;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          z-index: 10000;
          animation: slideIn 0.3s ease-out;
          max-width: 300px;
          font-size: 14px;
          line-height: 1.4;
        `;
        notification.textContent = message;

        // Add animation
        const style = document.createElement('style');
        style.textContent = `
          @keyframes slideIn {
            from {
              transform: translateX(400px);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
          @keyframes slideOut {
            from {
              transform: translateX(0);
              opacity: 1;
            }
            to {
              transform: translateX(400px);
              opacity: 0;
            }
          }
        `;
        document.head.appendChild(style);
        document.body.appendChild(notification);

        // Remove after 4 seconds with animation
        setTimeout(() => {
          notification.style.animation = 'slideOut 0.3s ease-out';
          setTimeout(() => {
            notification.remove();
            style.remove();
          }, 300);
        }, 4000);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
